import { BubbleMetadata } from '@/components/public/Visualisations/BubblesV2/Metadata'
import { defaultBubblePosition } from '@/constants'
import typedStore from '@/store/typedStore'
import { Coordinate2D, Dimensions, Path } from '@/types'

const PADDING = 50

export class ClusterMetadata {
  path: Path
  private _position: Coordinate2D = defaultBubblePosition()
  private _bubbles: Record<string, BubbleMetadata> = {}

  constructor(path: Path) {
    this.path = path
  }

  get boundingBoxSize(): Dimensions {
    let totalArea = 0
    for (const radius of this.bubblesRadii) {
      totalArea += Math.pow(radius, 2)
    }
    let diameter = Math.sqrt(totalArea) * 2
    if (diameter > 0) {
      diameter += PADDING
    }
    return { width: diameter, height: diameter }
  }

  get bubbles() {
    return Object.values(this._bubbles)
  }

  get storyColour() {
    return (
      typedStore.activeVisualisation.visualisationStore.entities.nodes.colour(this.path.level1) ??
      'black'
    )
  }

  get position(): Coordinate2D {
    return this._position
  }

  set position(value: Coordinate2D) {
    this._position = value
    this.bubbles.forEach((bubble) => {
      bubble.destinationPosition = this._position
    })
  }

  addBubble(bubble: BubbleMetadata) {
    this._bubbles[bubble.path.toString()] = bubble
  }

  removeBubble(bubble: BubbleMetadata) {
    delete this._bubbles[bubble.path.toString()]
  }

  clearBubbles() {
    this._bubbles = {}
  }

  private get bubblesRadii() {
    return this.bubbles.map((bubble) => bubble.displacementRadius)
  }
}
